import { Box, SimpleGrid } from "@chakra-ui/react";
import { DISCIPLINES } from "./homeContent";
import { Body, Card, CheckList, H3, Inner, Intro, Mono, Section, alpha, useHomeTokens } from "./primitives";

/** #platform — "Three disciplines, one stack". */
export const Platform = () => {
  const t = useHomeTokens();
  return (
    <Section id="platform">
      <Inner>
        <Intro
          kicker="What we build"
          title="Three disciplines, one stack"
          lead="Web, blockchain and AI engineering delivered by the same team that maintains the platform underneath your business."
        />
        <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} gap="20px">
          {DISCIPLINES.map((d) => (
            <Card
              key={d.number}
              gap="18px"
              borderColor={d.highlight ? t.primaryBorder : t.cardBorder}
              bg={
                d.highlight
                  ? `linear-gradient(135deg, ${alpha(t.primary, 0.09)} 0%, ${alpha(t.bg, 0.7)} 55%, ${alpha(t.bg, 0.8)} 100%)`
                  : t.cardGradient
              }
              _hover={{ borderColor: d.highlight ? t.primaryBorderHover : t.primaryBorder }}
            >
              <Mono letterSpacing=".12em" color={alpha(t.text, 0.3)}>
                {d.number}
              </Mono>
              <H3 fontSize="1.4rem">{d.title}</H3>
              <Body fontSize=".95rem" lineHeight="1.65">
                {d.body}
              </Body>
              <CheckList items={d.points} mt="2px" />
              <Box mt="auto" pt="22px" borderTop="1px solid" borderColor={t.hairline}>
                <Mono fontSize="11.5px" color={t.textFaint}>
                  {d.tags}
                </Mono>
              </Box>
            </Card>
          ))}
        </SimpleGrid>
      </Inner>
    </Section>
  );
};
